import { SgwtHelpCenter } from '@sgwt/sgwt-widgets-react';

export const HelpCenter = () => (
  <aside>
    <SgwtHelpCenter applicationId={import.meta.env.VITE_APP_ID as string} mailSubject="Help center message"  />
  </aside>
);
